<template>
  <div :class="[p_active?'c1_1_1act':'','c1_1_1']">
    <p @click="a_act(p_id)">{{ p_title }}</p>
    <i
      class="el-icon-close"
      style="float: right;font-size: 14px;color:#cbc;padding: 2px;"
      @click="a_close(p_id)"/>
  </div>
</template>
<script type="text/javascript">
export default{
  name: 'CMenubox',
  props: {
    p_id: {
      type: Number,
      default: 0
    },
    p_title: {
      type: String,
      default: ''
    },
    p_active: {
      type: Boolean,
      default: false
    },
    a_close: {
      type: Function,
      default: null
    },
    a_act: {
      type: Function,
      default: null
    }
  },
  data: function() {
    return {
    }
  },
  watch: {
    p_active: {
      handler(newV, oldV) {
        // console.log('01_menubox.watch.1', newV)
      },
      deep: true
    }
  },
  methods: {
  }
}
</script>
<style>/**scoped */
.c1_1_1{
  max-width: 150px;
  min-width: 80px;
  display: flex;
  flex-direction: row;
  height: 20px;
  background-color: rgba(166, 187, 204, 0.349);
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  margin-top: 4px;
  margin-right: 2px;
  padding: 3px;

  font-size: 12px;
  cursor: pointer;
  /*color: aliceblue;*/
}
.c1_1_1act{
  font-weight: bolder;
  color:white;
  background-image: linear-gradient(rgb(73, 134, 224),rgb(10, 53, 119),rgb(51, 31, 31));/*
  background-image: linear-gradient(rgba(39, 63, 71, 0.904),rgba(59, 92, 102, 0.904),rgba(47, 72, 80, 0.904),rgba(39, 63, 71, 0.904));*/
}
.c1_1_1 p{
  width: 90%;
  padding: 0 5px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/comps/c1_tab/01_menubox.vue